import { useState } from 'react';
import apiService from '../../axios/apiService';
import { message } from 'antd';

export const useInvoiceEmailSender = () => {
  const [loading, setLoading] = useState(false);
  const sentInvoiceEmail = async (
    invoiceId,
    { sendTo, moduleAccess, withInvoice }
  ) => {
    // Fetch case
    setLoading(true);
    try {
      await apiService.sendInvoiceEmail(invoiceId, {
        sendTo,
        moduleAccess,
        withInvoice,
      });
      message.success('Invoice email sent successfully');
    } catch (error) {
      console.error('Error: ', error);
      message.error('Failed to send invoice email');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    sentInvoiceEmail,
  };
};
